import { ReportStatusGroup } from "../../utils/constants";
import { getReportStatusIcon } from "../../utils/gaiaUtils";

export const GaReportStatusIcon = ({ reportStatusGroup }: { reportStatusGroup: ReportStatusGroup }) => {
    const { icon: Icon, size, color } = getReportStatusIcon(reportStatusGroup);

    return <Icon size={size} color={color} />;
};